module.exports = __webpack_public_path__ + "static/media/cover-real-size.7d1f2b01.jpg";